import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Paper, IconButton, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';

import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getAssignmentShipments } from '@/repositories/HttpRepository';

import MuiVirtualizedTable from '@/components/table/MuiVirtualizedTable';

import { shipmentsState, origShipmentsState } from './States';

export default function ListAssignmentShipments() {
  const setOrigAssignmentShipments = useSetRecoilState(origShipmentsState);
  const shipments = useRecoilValue(shipmentsState);
  const { id } = useParams();

  useEffect(() => {
    getAssignmentShipments(id).then((resp) => {
      if (resp.ok) {
        setOrigAssignmentShipments(resp.data);
      }
    });
  }, []);// eslint-disable-line react-hooks/exhaustive-deps

  const columns = [
    {
      width: 50,
      label: 'ID',
      dataKey: 'id',
    },
    {
      width: 120,
      label: 'Label',
      dataKey: 'label',
    },
    {
      width: 120,
      label: 'Status',
      dataKey: 'status',
    },
    {
      width: 120,
      label: 'Client',
      dataKey: 'client_id',
    },
    {
      width: 120,
      label: 'Warehouse ID',
      dataKey: 'warehouse_id',
    },
    {
      width: 250,
      label: 'Dropoff Earliest Time',
      dataKey: 'dropoff_earliest_ts',
    },
    {
      width: 250,
      label: 'Dropoff Latest Time',
      dataKey: 'dropoff_latest_ts',
    },
    {
      label: 'Actions',
      dataKey: 'actions',
      renderer: (rowData) => (
        <IconButton onClick={() => {/* empty */}}>
          <AccessAlarmIcon />
        </IconButton>
      ),
    },
  ];

  return (
    <Dialog open={true} fullWidth={true} maxWidth={'lg'} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
        Shipments
      </DialogTitle>
      <DialogContent>
        {shipments && (
          <Paper style={{ height: '500px', width: '100%' }}>
            <MuiVirtualizedTable
              rowCount={shipments.length}
              rowGetter={({ index }) => shipments[index]}
              columns={columns}
            />
          </Paper>
        )}
      </DialogContent>
      <DialogActions>
        <Button disableElevation autoFocus color="primary" onClick={() => {/* empty */}}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
